export enum BillingNoticeAction {
    UPGRADE = 'upgrade',
    UPDATE_CC_DETAILS = 'update',
    NO_ACTION = 'no_action'
}
